import {
  required,
  decimal,
  minValue,
  integer,
  maxLength
} from "vuelidate/lib/validators";
import date from "@/validation/date";

export default {
  report: {
    hcpIndAmount: { required, integer, minValue: minValue(0) },
    hcpIndRegCost: { required, decimal, minValue: minValue(0) },
    hcpIndTravelCost: { required, decimal, minValue: minValue(0) },
    hcpIndBasicSalary: { required, decimal, minValue: minValue(0) },
    hcpIndAdditionalSalary: { required, decimal, minValue: minValue(0) },

    hcpGrpAmount: { required, integer, minValue: minValue(0) },
    hcpGrpRegCost: { required, decimal, minValue: minValue(0) },
    hcpGrpTravelCost: { required, decimal, minValue: minValue(0) },
    hcpGrpBasicSalary: { required, decimal, minValue: minValue(0) },
    hcpGrpAdditionalSalary: { required, decimal, minValue: minValue(0) },

    hcoIndAmount: { required, integer, minValue: minValue(0) },
    hcoIndDonation: { required, decimal, minValue: minValue(0) },
    hcoIndRegCost: { required, decimal, minValue: minValue(0) },
    hcoIndTravelCost: { required, decimal, minValue: minValue(0) },
    hcoIndSponsorship: { required, decimal, minValue: minValue(0) },
    hcoIndBasicSalary: { required, decimal, minValue: minValue(0) },
    hcoIndAdditionalSalary: { required, decimal, minValue: minValue(0) },

    hcoGrpAmount: { required, integer, minValue: minValue(0) },
    hcoGrpDonation: { required, decimal, minValue: minValue(0) },
    hcoGrpRegCost: { required, decimal, minValue: minValue(0) },
    hcoGrpTravelCost: { required, decimal, minValue: minValue(0) },
    hcoGrpSponsorship: { required, decimal, minValue: minValue(0) },
    hcoGrpBasicSalary: { required, decimal, minValue: minValue(0) },
    hcoGrpAdditionalSalary: { required, decimal, minValue: minValue(0) },

    rndCost: { required, decimal, minValue: minValue(0) },

    reportUrl: { maxLength: maxLength(255) },
    organizationComments: { maxLength: maxLength(500) },
    approverComments: { maxLength: maxLength(500) }
  }
};
